import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-mapfre-button',
  templateUrl: './mapfre-button.component.html',
  styleUrls: ['./mapfre-button.component.scss'],
})
export class MapfreButtonComponent implements OnInit , AfterViewInit  {
  @ViewChild('mapfreButton') mapfreButton: ElementRef;

  @Input() type: 'primary' | 'dark' | 'clear' | 'link' | 'borderD' | 'clearDark';
  @Input() expand: 'block';
  @Input() slot: 'start' | 'end';
  @Input() icon: string;
  @Input() backgroundColor: string;
  @Input() textColor: string;
  @Input() classList: string;
  @Input() disabled: boolean;
  @Input() text: string;
  @Input() mt: string | number;
  @Input() fw: '500' | '700';
  @Input() size: 's' | 'sm' | 'm' | 'l' | 'xl';

  buttonWidth: number;

  constructor() {
    this.classList = '';
    this.type = 'primary';
    this.mt = '8';
    this.fw = '500';
    this.slot = 'start';
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.setButtonSize();
  }

  setButtonSize() {
    if (this.expand === 'block') {
      return;
    }
    this.mapfreButton.nativeElement.setAttribute('size', this.size);
  }
}
